import { T } from "../theme";

// Generate initials from display name
function getInitials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

// Pick a deterministic color from uid
const COLORS = [T.green, T.blue, "#A855F7", T.orange, "#EC4899", "#14B8A6"];
function colorFromUid(uid) {
  if (!uid) return COLORS[0];
  let hash = 0;
  for (let i = 0; i < uid.length; i++) hash = (hash * 31 + uid.charCodeAt(i)) | 0;
  return COLORS[Math.abs(hash) % COLORS.length];
}

export default function Avatar({ user, size = 40 }) {
  const initials = user?.initials || getInitials(user?.displayName);
  const color = user?.color || colorFromUid(user?.uid);

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Barlow Condensed', sans-serif",
        fontWeight: 700,
        fontSize: size * 0.38,
        color: "#fff",
        flexShrink: 0,
        border: `2px solid ${T.border}`,
      }}
    >
      {initials}
    </div>
  );
}

export { getInitials, colorFromUid };
